/*------------------------------------*\
    CONSULTATION COUNTDOWN MODULE
\*------------------------------------*/
var countdown = require("../../site/_data/base");

class ConsultationCountdown {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        var end = new Date(countdown.consultation.countdown_end);

        var _second = 1000;
        var _minute = _second * 60;
        var _hour = _minute * 60;
        var _day = _hour * 24;

        var note = document.getElementById("consultation-countdown");
        var timer;

        function showRemaining() {
            var now = new Date();
            var distance = end - now;

            if (distance < 0) {
                clearInterval(timer);
                note.innerHTML = "Consultation has closed";

                return;
            }

            var days = Math.floor(distance / _day);
            var hours = Math.floor((distance % _day) / _hour);
            var minutes = Math.floor((distance % _hour) / _minute);
            var seconds = Math.floor((distance % _minute) / _second);

            note.innerHTML = "Consultation closes in ";
            note.innerHTML += days + " days ";
            note.innerHTML += hours + " hrs ";
            note.innerHTML += minutes + " mins ";
            note.innerHTML += seconds + " secs";
        }

        timer = setInterval(showRemaining, 1000);
    }
}

export default ConsultationCountdown;
